"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.projects = exports.initialState = exports.initialFilterOptions = exports.initialOrderByOptions = void 0;
const ActionTypes = require("../actionTypes/projects");
const monocle_ts_1 = require("monocle-ts");
const fp = require("fp-ts");
exports.initialOrderByOptions = {
    orderBy: 'name',
    order: 'asc'
};
exports.initialFilterOptions = {};
exports.initialState = {
    projectListStatus: 'STANDBY',
    projects: [],
    searchString: '',
    limit: 350,
    offset: 0,
    itemsPerPage: [350, 700, 1400],
    orderByOptions: Object.assign({}, exports.initialOrderByOptions),
    filterOptions: Object.assign({}, exports.initialFilterOptions),
    showBookmarked: false,
    showArchived: false,
    selected: []
};
const projectListStatusLens = monocle_ts_1.Lens.fromProp('projectListStatus');
const searchStringLens = monocle_ts_1.Lens.fromProp('searchString');
const filterOptionsLens = monocle_ts_1.Lens.fromProp('filterOptions');
const showBookmarked = monocle_ts_1.Lens.fromProp('showBookmarked');
const showArchived = monocle_ts_1.Lens.fromProp('showArchived');
const offsetLens = monocle_ts_1.Lens.fromProp('offset');
const limitLens = monocle_ts_1.Lens.fromProp('limit');
const orderByOptionsLens = monocle_ts_1.Lens.fromProp('orderByOptions');
const selectedLens = monocle_ts_1.Lens.fromProp('selected');
const projectsLens = monocle_ts_1.Lens.fromProp('projects');
function updateBookmark(state, data, bookmarkStatus) {
    // Mark as bookmarked/unbookmarked
    return projectsLens.modify((projects) => projects.map((project) => data.indexOf(project.id) > -1
        ? Object.assign(Object.assign({}, project), { bookmarked: bookmarkStatus }) : project))(state);
}
const projects = (state = exports.initialState, action) => {
    switch (action.type) {
        case ActionTypes.FETCH_PROJECTS_REQUEST:
            return projectListStatusLens.set('FETCHING')(state);
        case ActionTypes.FETCH_PROJECTS_SUCCESS: {
            return fp.function.compose(projectListStatusLens.set('FETCHED'), projectsLens.set(action.payload))(state);
        }
        case ActionTypes.FETCH_PROJECTS_FAILURE:
            return projectListStatusLens.set('FAILED')(state);
        case ActionTypes.SET_LIMIT: {
            return limitLens.set(action.payload)(state);
        }
        case ActionTypes.SET_OFFSET: {
            return offsetLens.set(action.payload)(state);
        }
        case ActionTypes.SET_ORDER_BY_OPTIONS: {
            return orderByOptionsLens.set(action.payload)(state);
        }
        case ActionTypes.SET_SEARCH_STRING: {
            return searchStringLens.set(action.payload)(state);
        }
        case ActionTypes.SET_FILTER_OPTIONS:
            return filterOptionsLens.modify((filters) => {
                const copy = Object.assign({}, filters);
                if (action.payload.value) {
                    copy[action.payload.filter] = action.payload.value;
                }
                else {
                    delete copy[action.payload.filter];
                }
                return copy;
            })(state);
        case ActionTypes.BOOKMARK_PROJECT_SUCCESS: {
            const { data } = action.result;
            return updateBookmark(state, data, true);
        }
        case ActionTypes.UNBOOKMARK_PROJECT_SUCCESS: {
            const { data } = action.result;
            return updateBookmark(state, data, false);
        }
        case ActionTypes.BOOKMARK_PROJECT_REQUEST: {
            const data = action.payload.id;
            return updateBookmark(state, data, true);
        }
        case ActionTypes.UNBOOKMARK_PROJECT_REQUEST: {
            const data = action.payload.id;
            return updateBookmark(state, data, false);
        }
        case ActionTypes.CLEAR_FILTERS:
            return Object.assign(Object.assign({}, state), { searchString: '', showBookmarked: false, showArchived: false, orderByOptions: Object.assign({}, exports.initialOrderByOptions), filterOptions: {} });
        case ActionTypes.TOGGLE_SHOW_BOOKMARKS:
            return showBookmarked.modify((x) => !x)(state);
        case ActionTypes.TOGGLE_SHOW_ARCHIVED:
            return showArchived.modify((x) => !x)(state);
        case ActionTypes.TOGGLE_SELECTION:
            return selectedLens.modify((l) => {
                const selected = [...l];
                const i = selected.findIndex((f) => f.id === action.payload.id);
                if (i === -1) {
                    selected.push(action.payload);
                }
                else {
                    selected.splice(i, 1);
                }
                return selected;
            })(state);
        case ActionTypes.CLEAR:
            return Object.assign({}, exports.initialState);
        default:
            return state;
    }
};
exports.projects = projects;
//# sourceMappingURL=projects.js.map